/*
    rtAccordions
    Version:1.0
    Author:Rory Saxby & Jake Upshall (Logic)
    Dependencies: jQuery

    EXAMPLE:

    *** Initialise ***

    var generalAccordions = new logicjs.rtAccordions({
        container: ".page-accordions",
        accordionsClass: ".general-accordion",
        accordionCtrlTarget: ".toggle-ctrl",
        hiddenClass: "hidden",
        accordionView: ".accordion-view",
        loadingClass: "loading"
    });

    *** Markup ***
    <div class="page-accordions">
        <div class="general-accordion">
            <button class="toggle-ctrl">Link 1</button>
            <div class="accordion-view">
                <!-- content here --> 
            </div>
        </div>
        <div class="general-accordion">
            <button class="toggle-ctrl">Link 2</button>
            <div class="accordion-view">
                <!-- content here -->
            </div>
        </div>
        <div class="general-accordion">
            <button class="toggle-ctrl">Link 3</button>
            <div class="accordion-view">
                <!-- content here -->
            </div>
        </div>
    </div>

 */

if (typeof logicjs === "undefined") var logicjs = {};

logicjs.rtAccordions = function (opts) {
    this.container = $(opts.container);
    this.accordionsClass = opts.accordionsClass;
    this.accordions = this.container.find(this.accordionsClass);
    this.accordionCtrlTarget = opts.accordionCtrlTarget;
    this.accordionClickCallback = opts.accordionClickCallback || false;
    this.hiddenClass = opts.hiddenClass || "inactive";
    this.loadActiveClass = opts.loadActiveClass || "initially-opened";
    this.onLoadActiveCheckCallback = opts.onLoadActiveCheckCallback || false;
    this.accordionView = opts.accordionView;
    this.parentAccordionView = opts.parentAccordionView || null;
    this.loadingClass = opts.loadingClass || "loading";
    this.activeClass = opts.activeClass || "active";
    this.storeOpenCookie = opts.storeOpenCookie || false; // {name:"", value:"", expires} || false;
    this.toggleAccordions = opts.toggleAccordions || false;
    this.toggleCallback = opts.toggleCallback || false;
    this.setAccordionHeights = opts.setAccordionHeights || true;
    this.disableAccordionClick = opts.disableAccordionClick || false;

    this.openAccordions = [];

    this.setupAccordions();
};

logicjs.rtAccordions.prototype.bindAccordions = function () {
    for (var i = 0; i < this.accordions.length; i++) {
        var _ = this;
        $(this.accordions[i]).find(this.accordionCtrlTarget).off('click').on('click', function (e) {
            e.preventDefault();
            if (!_.disableAccordionClick) _.setActiveAccordion($(this).parents(_.accordionsClass));
        });
    };
};

logicjs.rtAccordions.prototype.setActiveAccordion = function (selected, disableCookieUpdate) {
    var addItem;
    if (selected.hasClass(this.hiddenClass)) {
        if (this.toggleAccordions) this.hideAll();
        selected.removeClass(this.hiddenClass);
        selected.addClass(this.loadActiveClass);
        addItem = true;
        //this.openSelectedView(selected);
    } else {
        selected.addClass(this.hiddenClass);
        selected.removeClass(this.loadActiveClass);
        this.hideSelectedView(selected);
        addItem = false;
    };

    if (this.storeOpenCookie && !disableCookieUpdate) {
        this.updateStoredCookie(selected, addItem);
        this.updateCookie();
    };

    if (this.toggleCallback) this.toggleCallback();
};

logicjs.rtAccordions.prototype.updateCookie = function () {
    var value = JSON.stringify(this.storedCookie);
    logicjs.setCookie(this.storeOpenCookie.name, value, 7);
};

logicjs.rtAccordions.prototype.updateStoredCookie = function (accordion, addItem) {
    var name = accordion.find(this.accordionCtrlTarget).attr(this.storeOpenCookie.attr);
    if (name == "" || name == null || name == undefined) return;

    if (this.storedCookie.length > 0) {
        for (var i = 0; i < this.storedCookie.length; i++) {
            if (this.storedCookie[i] === name) {
                if (!addItem) this.storedCookie.splice(i, 1);
                return;
            };
        };
        if (addItem) this.storedCookie.push(name);
    } else {
        if (addItem) this.storedCookie.push(name);
    };
};

// logicjs.rtAccordions.prototype.openSelectedView = function (selected) {
//     var view = selected.find(this.accordionView),
//         height = view[0].scrollHeight * 3;

//     view[0].style.maxHeight = height + "px";
//     this.setParentView(view, height);
// };

// logicjs.rtAccordions.prototype.setParentView = function (view, height) {
//     if (this.parentAccordionView !== null) {
//         var parentView = $(view).parents(this.parentAccordionView);
//         parentView[0].style.maxHeight = parentView[0].scrollHeight + height + "px";
//     };
// };

logicjs.rtAccordions.prototype.hideAll = function () {
    for (var i = 0; i < this.accordions.length; i++) {
        var selected = $(this.accordions[i]);
        selected.addClass(this.hiddenClass);
        selected.removeClass(this.loadActiveClass);
        this.hideSelectedView(selected);
        this.updateStoredCookie(selected, false);

    };
    this.updateCookie();
};

logicjs.rtAccordions.prototype.hideSelectedView = function (selected) {
    //selected.find(this.accordionView)[0].style.maxHeight = 0;
};

logicjs.rtAccordions.prototype.removeAllSetHeights = function () {
    for (var i = 0; i < this.accordions.length; i++) {
        var view = $(this.accordions[i]).find(this.accordionView);
        view.attr('style', '');
    };
};

logicjs.rtAccordions.prototype.unset = function () {
    for (var i = 0; i < this.accordions.length; i++) {
        $(this.accordions[i]).find(this.accordionCtrlTarget).unbind('click');
        $(this.accordions[i]).removeClass(this.hiddenClass);
        $(this.accordions[i]).find(this.accordionView)[0].style = "";
    };
};

logicjs.rtAccordions.prototype.getStoredCookie = function () {
    var value = logicjs.getCookie(this.storeOpenCookie.name);
    this.storedCookie = [];
    if (value !== "") this.storedCookie = JSON.parse(value);
}

logicjs.rtAccordions.prototype.setupAccordions = function () {
    if (this.storeOpenCookie) this.getStoredCookie();

    this.container.addClass(this.loadingClass);
    this.bindAccordions();
    this.container.removeClass(this.loadingClass);
};

/* Functions for external use */

logicjs.rtAccordions.prototype.changeOpt = function (opt, value) {
    this[opt] = value;

    switch (opt) {
        case "toggleAccordions":
            if (value) {
                this.hideAll();
            }
            break;
        case "setAccordionHeights":
            if (value) {
                this.hideAll();
            } else {
                this.removeAllSetHeights();
            }
            break;
    }
};